import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@src/utils/ui';

export const MemberBadge = ({ className }) => {
    return (
        <img
            className={cn('bcaa-verified-member-img', className)}
            src='/assets/images/BCAA-Member-Badge-Small-Vehicle-Thumbnail-and-Vehicle-Display.svg'
            alt='BCAA Member'
            title='BCAA Member'
        />
    );
};

MemberBadge.propTypes = {
    className: PropTypes.string
};

export default MemberBadge;
